// @file Surface post group by store
// This is new grouping logic that support group by section, color, author, and single-select.
// Only use this store if 'groupPostsV2' flip is enabled, else use surface_sections.ts.

import { useSurfaceWishArrangementStore } from '@@/pinia/surface_wish_arrangement'
import type { WallGroupPost } from '@@/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useSurfacePostGroupByStore = defineStore('surfacePostGroupByStore', () => {
  const surfaceWishArrangementStore = useSurfaceWishArrangementStore()

  // State
  const groupUnderActionId = ref<WallGroupPost['id'] | null>(null)
  const groupUnderActionRightClickCoordinates = ref<{ x: number; y: number } | null>(null)

  // Getters
  const groupUnderAction = computed(() => getGroupById(groupUnderActionId.value))
  const groupUnderActionTitle = computed(() => {
    if (groupUnderAction.value == null) return null
    if ('title' in groupUnderAction.value && groupUnderAction.value.title != null) return groupUnderAction.value.title
    return groupUnderAction.value.id
  })

  // Actions
  const getGroupById = (groupId: WallGroupPost['id'] | null): WallGroupPost | null => {
    return surfaceWishArrangementStore.sortedGroups.find((g) => g.id === groupId) ?? null
  }

  const hideGroupActionMenu = (): void => {
    groupUnderActionId.value = null
    groupUnderActionRightClickCoordinates.value = null
  }

  return {
    // State
    groupUnderActionId,
    groupUnderActionRightClickCoordinates,

    // Getters
    groupUnderAction,
    groupUnderActionTitle,

    // Actions
    getGroupById,
    hideGroupActionMenu,
  }
})
